import React, { useRef } from 'react';
import { Line } from 'react-chartjs-2';
import CalendarComp from '../../CalendarComp/CalendarComp';

const LineChart = ({data,filters,handleFilter}) => {
  const chartRef = useRef(null);
  const lineHandleFilter=(field,value)=>{
    console.log("field",field);
    console.log("value",value);
    handleFilter(filters.view||field,value)
  }

  let month=[], totalOrders=[],totalOrderPayment=[],adminEarn=[],storeEarn=[],totalDeliveryPayment=[], deliverymanEarn=[]

  data?.forEach((d,i)=>{
    month.push(d.month)
    totalOrders.push(d.totalOrders)
    totalOrderPayment.push(d.totalOrderPayment)    
    storeEarn.push(d.storeEarn)
    adminEarn.push(d.adminEarn)
    totalDeliveryPayment.push(d.totalDeliveryPayment)
    deliverymanEarn.push(d.deliverymanEarn)
})
  
  const lineData = {
    labels: month,
    datasets: [
      {
        label: 'Total Order',
        backgroundColor: 'rgba(255,99,132,0.4)',
        borderColor: 'rgba(255,99,132,1)',
        borderWidth: 1,
        hoverBackgroundColor: 'rgba(255,99,132,0.6)',
        hoverBorderColor: 'rgba(255,99,132,1)',
        data: totalOrders,
      },
      {
        label: 'Total Payments',
        backgroundColor: 'rgba(54,162,235,0.4)',
        borderColor: 'rgba(54,162,235,1)',
        borderWidth: 1,
        hoverBackgroundColor: 'rgba(54,162,235,0.6)',
        hoverBorderColor: 'rgba(54,162,235,1)',
        data: totalOrderPayment,
      },
      {
        label: 'Vendor Earnings',
        backgroundColor: 'rgba(75,192,192,0.4)',
        borderColor: 'rgba(75,192,192,1)',
        borderWidth: 1,
        hoverBackgroundColor: 'rgba(75,192,192,0.6)',
        hoverBorderColor: 'rgba(75,192,192,1)',
        data: storeEarn,
      },
      {
        label: 'Admin Earnings',
        backgroundColor: 'rgba(75,192,192,0.4)',
        borderColor: 'rgba(75,192,192,1)',
        borderWidth: 1,
        hoverBackgroundColor: 'rgba(75,192,192,0.6)',
        hoverBorderColor: 'rgba(75,192,192,1)',
        data: adminEarn,
      },
      {
        label: 'Deliveryman Earnings',
        backgroundColor: 'rgba(153,102,255,0.4)',
        borderColor: 'rgba(153,102,255,1)',
        borderWidth: 1,
        hoverBackgroundColor: 'rgba(153,102,255,0.6)',
        hoverBorderColor: 'rgba(153,102,255,1)',
        data: deliverymanEarn,
      },
      {
        label: 'Total Delivery Payment',
        backgroundColor: 'rgba(255,206,86,0.4)',
        borderColor: 'rgba(255,206,86,1)',
        borderWidth: 1,
        hoverBackgroundColor: 'rgba(255,206,86,0.6)',
        hoverBorderColor: 'rgba(255,206,86,1)',
        data: totalDeliveryPayment,
      },
    
    ],
  };

  // const data = {
  //   labels: [
  //     "January", "February", "March", "April", "May", "June",
  //     "July", "August", "September", "October", "November", "December"
  //   ],
  //   datasets: [
  //     {
  //       label: 'Admin Earning',
  //       data: [35, 59, 80, 81, 56, 55, 40],
  //       fill: false,
  //       backgroundColor: 'rgba(75,192,192,0.4)',
  //       borderColor: 'rgba(75,192,192,1)',
  //     },
  //     {
  //       label: 'Admin Paid',
  //       data: [15, 69, 50, 81, 56, 85, 140],
  //       fill: false,
  //       backgroundColor: 'rgba(54,162,235,0.4)',
  //       borderColor: 'rgba(54,162,235,1)',
  //     },
  //     {
  //       label: 'Paid Deliveryman',
  //       data: [6, 69, 1, 81, 56, 65, 140],
  //       fill: false,
  //       backgroundColor: 'rgba(153,102,255,0.4)',
  //       borderColor: 'rgba(153,102,255,1)',
  //     },
  //     {
  //       label: 'Paid store',
  //       data: [65, 9, 50, 81, 16, 85, 140],
  //       fill: false,
  //       backgroundColor: 'rgb(75, 292, 192)',
  //       borderColor: 'rgba(75, 292, 192,.8)',
  //     },
  //     {
  //       label: 'Total',
  //       data: [0, 39, 150, 81, 26, 85, 140],
  //       fill: false,
  //       backgroundColor: 'rgba(255,206,86,0.4)',
  //       borderColor: 'rgba(255,206,86,1)',
  //     },
  //   ],
  // };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        display: true,
      },
      y: {
        display: true,
      },
    },
  };

  return (
    <div  className='chart-container no-flex-grow-card'>
       <div className='d-flex gap-1 align-items-center'> 
        <h1>Earning</h1>
        <CalendarComp range={filters?.range||false}  view={filters.view||"month"} sx={{borderRadius:"20px"}} handleFilter={lineHandleFilter}/>
        </div>
      <div style={{ height: '20rem' }} >
      <Line ref={chartRef} data={lineData} options={options} />
      </div>
     
    </div>
  );
};

export default LineChart;
